<span class="tooltip__text">{{text | translate}}</span>
